<template>
  <div class="wechat-container">
    <!-- 顶部安全区占位 + 悬浮操作栏 -->
    <div class="safe-area-top"></div>
    <div class="header-bar glass-header profit-note" :class="{ 'is-sticky': isSticky }">
      <!-- <div class="header-tip"> 分润 = 售价 - 结算价（公众号充值适用）</div> -->
        <span class="note-item">分润 = 售价 - 结算价（公众号充值适用）</span>
    </div>

    <!-- 主内容区 -->
    <div class="main-content">
      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        success-text="刷新成功"
        pulling-text="下拉刷新"
        loosing-text="释放刷新"
      >

      <!-- 空状态 -->
      <van-empty
        v-if="list.length === 0"
        image="search"
        description="暂无套餐数据"
      >
      </van-empty>
        <van-list v-else
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="loadMore"
          :offset="100"
        >
          <!-- 优化后的目标导向型卡片 -->
          <div
            v-for="(item, index) in list"
            :key="item.packageId || index"
            class="profit-card"
            @click="toggleDetail(index)"
          >
            <!-- ✅ 修改点1：卡片头部替换为配置按钮 -->
            <div class="card-header">
              <h3 class="package-name">{{ item.mobilePkName }}</h3>
              <van-button
                size="small"
                plain
                class="config-price-btn"
                @click.stop="openPriceConfig(item)"
              >
                <van-icon name="edit" />
                设置售价
              </van-button>
            </div>

            <!-- 核心指标区：流量 + 分润（放大突出） -->
            <div class="core-metrics">
              <div class="metric-item flow-metric">
                <span class="metric-label">套餐流量</span>
                <span class="metric-value">{{ formatFlow(item.flow) }}</span>
              </div>

              <div class="metric-item flow-metric">
                <span class="metric-label">有效期</span>
                <span class="metric-value">{{durationDescriptionTpl(item)}}</span>
              </div>
              <div class="metric-item flow-metric">
                <span class="metric-label">当前售价</span>
                <span class="metric-value">¥{{ item.salePrice }}</span>
              </div>
              <div class="metric-divider"></div>
              <div class="metric-item profit-metric" v-if="item.salePrice > settlePriceTpl(item)">
                <span class="metric-label">预估分润</span>
                <span
                  class="metric-value profit-amount"
                  :class="item.salePrice >= item.baseSettlePrice ? 'positive' : 'negative'"
                >
                  ¥{{ (item.salePrice - settlePriceTpl(item)) }}
                </span>
                <span class="metric-sub">
                  (¥{{ item.salePrice}} - ¥{{ settlePriceTpl(item) }})
                </span>
              </div>
            </div>

            <!-- ✅ 修改点2：底部明细区增加实时利润预览提示 -->
            <div class="price-detail-grid">
              <div class="detail-row">
                <span class="detail-label">结算价</span>
                <span class="detail-value">¥{{settlePriceTpl(item) }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">最低售价</span>
                <span class="detail-value">¥{{ item.baseSalePrice }}</span>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <div class="safe-area-bottom"></div>

    <!-- 日期选择器 -->
    <van-popup v-model="showDatePicker" position="bottom" round>
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择查询日期"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onDateConfirm"
        @cancel="showDatePicker = false"
      />
    </van-popup>

    <!-- ✅ 新增：售价配置半屏弹窗 -->
    <van-popup
      v-model="showConfigPopup"
      position="bottom"
      round
      :style="{ maxHeight: '70%' }"
      closeable
    >
      <div class="config-popup" v-if="currentConfigItem">
        <div class="popup-title">设置售价 · {{ currentConfigItem.mobilePkName }}</div>

        <div class="config-info">
          <div class="info-row">
            <span>结算价</span>
            <span class="readonly">¥{{ settlePriceTpl(currentConfigItem) }}</span>
          </div>
          <div class="info-row">
            <span>最低售价</span>
            <span class="readonly">¥{{ currentConfigItem.baseSalePrice }}</span>
          </div>
        </div>

        <div class="config-edit">
          <span class="edit-label">我的售价</span>
          <van-stepper
            v-model="editPrice"
            :min="currentConfigItem.baseSalePrice"
            :step="1"
            :precision="2"
            input-width="90px"
            button-size="40px"
          />
        </div>

        <div class="profit-preview">
          预估分润：
          <span :class="editProfit >= 0 ? 'positive' : 'negative'">
            ¥{{ editProfit }}
          </span>
        </div>

        <van-button
          type="primary"
          block
          round
          class="save-btn"
          :loading="saving"
          @click="savePrice"
        >
          确认保存
        </van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Dialog } from 'vant'
import * as packageApi from '@/api/package.js'
export default {
  name: 'WechatProfitManager',
  data () {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      isSticky: false,
      showDatePicker: false,
      currentDate: new Date(),
      minDate: new Date(2026, 0, 1),
      maxDate: new Date(),
      paramsList: {
        token: '',
        userId: '',
        page: 1,
        limit: 10,
        endRechargeDate: ''
      },
      list: [],
      // ✅ 新增：配置弹窗相关状态
      showConfigPopup: false,
      currentConfigItem: null,
      editPrice: 0,
      saving: false
    }
  },

  computed: {
    // ✅ 新增：实时计算编辑中的预估分润
    editProfit () {
      if (!this.currentConfigItem) return 0
      return this.editPrice - this.settlePriceTpl(this.currentConfigItem)
    }
  },

  methods: {
    durationDescriptionTpl (pkg) {
      const timeValue = parseInt(pkg.effectiveTime, 10)
      let durationDescription = ''
      switch (pkg.effectiveType) {
        case '01': // 按月
          if (timeValue === 1) {
            durationDescription = '1个月'
          } else if (timeValue % 12 === 0) {
            const years = timeValue / 12
            durationDescription = `${years}年`
          } else {
            durationDescription = `${timeValue}个月`
          }
          break
        case '02': // 按天
          if (timeValue === 1) {
            durationDescription = '1天'
          } else {
            durationDescription = `${timeValue}天`
          }
          break
      }
      return durationDescription
    },
    settlePriceTpl (d) {
      return d.parentMaxSalePrice > 0 ? d.parentMaxSalePrice : d.baseSettlePrice
    },
    formatFlow (flow) {
      return `${flow}MB`
      // return flow >= 1024 ? `${(flow / 1024).toFixed(1)}GB` : `${flow}MB`
    },

    // ✅ 新增：打开配置弹窗
    openPriceConfig (item) {
      this.currentConfigItem = item
      this.editPrice = item.salePrice
      this.showConfigPopup = true
    },

    // ✅ 新增：保存售价
    async savePrice () {
      if (this.editPrice < this.settlePriceTpl(this.currentConfigItem)) {
        this.$toast.fail(`售价不能低于结算价 ¥${this.settlePriceTpl(this.currentConfigItem)}`)
        return
      }
      Dialog.confirm({
        title: '是否确认更新？',
        message: '套餐：' + this.currentConfigItem.mobilePkName + ' \n 售价：￥' + this.editPrice
      }).then(() => {
        this.saving = true
        try {
          this.confirmSetPackageConfig()
        } catch (e) {
          this.$toast.fail('保存失败，请重试')
        } finally {
          this.saving = false
        }
      })
    },
    async confirmSetPackageConfig () {
      const {
        data: response
      } = await packageApi.setPackageConfig({
        token: this.$store.state.token,
        userId: this.$store.state.userID.split('a')[0],
        salePrice: this.editPrice,
        agentId: this.currentConfigItem.agentId,
        packageId: this.currentConfigItem.packageId,
        configId: this.currentConfigItem.configId
      })
      if (response.msg && response.msg.indexOf('请重新登录') !== -1) {
        this.$router.push('/login/no')
        return
      }
      if (response.code !== 0) {
        this.$toast.fail(response.msg)
      } else {
        this.getList(true)
        this.showConfigPopup = false
        this.$toast.success('售价已更新')
      }
    },

    toggleDetail (index) {
      // 保留原有折叠逻辑扩展位
    },

    onDateConfirm (value) {
      const y = value.getFullYear()
      const m = String(value.getMonth() + 1).padStart(2, '0')
      const d = String(value.getDate()).padStart(2, '0')
      this.paramsList.endRechargeDate = `${y}-${m}-${d}`
      this.paramsList.page = 1
      this.showDatePicker = false
      this.getList(true)
    },

    handleReset () {
      this.$dialog
        .confirm({ title: '温馨提示', message: '确定要重置查询条件吗？' })
        .then(() => {
          this.currentDate = new Date()
          this.paramsList.endRechargeDate = ''
          this.paramsList.page = 1
          this.getList(true)
        })
        .catch(() => {})
    },

    async getList (isRefresh = false) {
      try {
        this.loading = true
        // const res = await fetchOrderData(this.paramsList)
        const {
          data: res
        } = await packageApi.agentPackageList({
          token: this.$store.state.token,
          userId: this.$store.state.userID.split('a')[0],
          iccid: ''
        })
        const rows = res.extend?.List || []
        console.log(rows)
        if (isRefresh) {
          this.list = rows
          this.refreshing = false
        } else {
          this.list = [...this.list, ...rows]
        }
        if (rows.length < this.paramsList.limit) {
          this.finished = true
        } else {
          this.paramsList.page++
        }
      } catch (err) {
        console.error('获取数据失败:', err)
        this.$toast.fail('网络异常，请稍后重试')
        if (isRefresh) this.refreshing = false
      } finally {
        this.loading = false
      }
    },

    onRefresh () {
      this.paramsList.page = 1
      this.finished = false
      this.getList(true)
    },

    loadMore () {
      if (!this.loading && !this.finished) this.getList()
    },

    handleScroll () {
      this.isSticky = window.scrollY > 10
    }
  },

  mounted () {
    this.getList()
    window.addEventListener('scroll', this.handleScroll)
  },

  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped lang="less">
/* ========== 以下为您原有样式，仅追加配置按钮 & 弹窗样式 ========== */

.wechat-container {
  min-height: 100vh;
  background: #f5f6fa;
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  padding-top: env(safe-area-inset-top);
  padding-bottom: calc(env(safe-area-inset-bottom) + 24px);
}

.safe-area-top { height: env(safe-area-inset-top); }
.safe-area-bottom { height: env(safe-area-inset-bottom); }

.header-bar {
  position: sticky;
  top: env(safe-area-inset-top);
  z-index: 99;
  padding: 16px 20px;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(12px);
  transition: box-shadow 0.3s ease;
  &.is-sticky { box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06); }
}
.glass-header {
    /* 1. 核心：背景模糊 (兼容性写法) */
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 1.0) 30%,   /* 顶部几乎不透明，保证文字清晰 */
      rgba(255, 255, 255, 0.8) 60%,  /* 中间开始变透 */
      rgba(255, 255, 255, 0.5) 80%,  /* 中间开始变透 */
      rgba(255, 255, 255, 0.4) 100%     /* 底部完全透明，自然融入列表 */
    );
    box-shadow: 0 1px 0 rgba(0,0,0,0.05); /* 加一条极淡的底边框代替阴影，更清爽 */
    z-index: 100; /* 确保在最上层 */
  }
  /* 适配深色模式 (Dark Mode) */
  @media (prefers-color-scheme: dark) {
    .glass-header {
      box-shadow: 0 1px 0 rgba(255,255,255,0.05);
    }
  }

.header-tip {
  font-size: 22px;
  color: #969799;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  line-height: 1.5;
}

.header-actions {
  display: flex;
  gap: 14px;
  .action-btn {
    flex: 1;
    height: 52px;
    font-size: 24px;
    border-radius: 26px;
    line-height: 52px;
    font-weight: 500;
    :deep(.van-icon) {
      margin-right: 6px;
      font-size: 24px;
      vertical-align: middle;
    }
  }
}

.main-content { padding: 16px; }

.profit-card {
  background: #fff;
  border-radius: 20px;
  padding: 24px;
  margin-bottom: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
  transition: transform 0.2s ease;
  &:active { transform: scale(0.98); }
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  gap: 12px;
}

.package-name {
  font-size: 26px;
  font-weight: 600;
  color: #323233;
  margin: 0;
  line-height: 1.4;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ✅ 新增：配置售价按钮样式 */
.config-price-btn {
  flex-shrink: 0;
  white-space: nowrap;

  /* ✅ 核心尺寸：15px文字 + 36px高度，平衡可读性与克制感 */
  height: 36px !important;
  padding: 0 16px !important;
  font-size: 15px !important;
  line-height: 36px !important;
  border-radius: 8px !important;
  font-weight: 500;

  /* ✅ 业务强化：浅品牌绿底 + 品牌绿字 */
  background-color: rgba(7, 193, 96, 0.10) !important;
  color: #07C160 !important;
  border: none !important;

  /* 图标适配 */
  :deep(.van-icon) {
    margin-right: 6px;
    font-size: 16px;
    vertical-align: middle;
  }

  /* 交互反馈：温和增强，不喧宾夺主 */
  &:hover {
    background-color: rgba(7, 193, 96, 0.15) !important;
  }
}

.core-metrics {
  display: flex;
  align-items: center;
  padding: 18px 0;
  border-top: 1px dashed #ebebeb;
  border-bottom: 1px dashed #ebebeb;
  margin-bottom: 8px;
}

.metric-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.metric-divider {
  width: 1px;
  height: 48px;
  background: #ebebeb;
}

.metric-value {
  font-size: 32px;
  font-weight: 700;
  color: #323233;
  line-height: 1.2;
}

.metric-label {
  font-size: 22px;
  color: #969799;
  line-height: 1.5;
}

.metric-sub {
  font-size: 20px;
  color: #c8c9cc;
  margin-top: 2px;
  line-height: 1.4;
}

.profit-amount {
  font-size: 35px;
  font-weight: 800;
  line-height: 1.2;
  &.positive { color: #07c160; }
  &.negative { color: #ee0a24; }
}

.flow-metric .metric-value {
  font-size: 28px;
  color: #1989fa;
}

.price-detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 10px 0;
}

.detail-row {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 8px 0;
}

.detail-label {
  font-size: 22px;
  color: #969799;
  line-height: 1.5;
}

.detail-value {
  font-size: 24px;
  color: #969799;
  line-height: 1.4;
  &.highlight { color: #1989fa; }
  &.positive { color: #07c160; }
  &.warning { color: #ff976a; }
}

:deep(.van-pull-refresh__track) { min-height: calc(100vh - 140px); }

:deep(.van-empty) {
  padding: 60px 0;
  .van-empty__description {
    margin-bottom: 24px;
    font-size: 24px;
    color: #969799;
  }
  .van-button {
    width: 60%;
    margin: 0 auto;
    height: 52px;
    font-size: 24px;
    border-radius: 26px;
    line-height: 52px;
  }
}

/* ✅ 新增：配置弹窗样式 */
.config-popup {
  /* ✅ 核心修改：固定高度 + 底部安全区冗余 */
  height: calc(65vh + env(safe-area-inset-bottom));
  max-height: 80vh; /* 防止小屏设备溢出 */

  /* 布局调整：确保内容垂直排列，按钮始终沉底 */
  display: flex;
  flex-direction: column;

  padding: 24px 24px 0; /* 移除底部 padding，改由内部元素控制 */
  box-sizing: border-box;
}

.popup-title {
  font-size: 26px;
  font-weight: 600;
  color: #323233;
  margin-bottom: 20px;
  line-height: 1.4;
}

.config-info {
  background: #f7f8fa;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
  .info-row {
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    font-size: 22px;
    color: #969799;
    .readonly {
      color: #646566;
      font-weight: 500;
    }
  }
}

.config-edit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  .edit-label {
    font-size: 24px;
    font-weight: 600;
    color: #323233;
  }
}

.profit-preview {
  text-align: center;
  font-size: 22px;
  color: #969799;
  margin: 16px 0 24px;
  .positive { color: #07c160; font-weight: 700; font-size: 26px; }
  .negative { color: #ee0a24; font-weight: 700; font-size: 26px; }
}

// .save-btn {
//     height: 75px;
//   font-size: 26px;
//   border-radius: 26px;
//   line-height: 52px;
// }
.config-info,
.config-edit,
.profit-preview {
  flex-shrink: 0;
}
.save-btn {
  /* 布局基础 */
  margin-top: auto;
  flex-shrink: 0;
  width: 100%;

  /* ✅ 锁定验证过的黄金尺寸 */
  height: 75px !important;
  font-size: 32px !important;
  font-weight: 600 !important;
  letter-spacing: 1px;

  /* ✅ 形态与居中（消除扁平感 + 跨系统兼容） */
  border-radius: 16px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: 1 !important;

  /* ✅ 底部安全区全版本兼容 */
  margin-bottom: calc(24px + env(safe-area-inset-bottom));
  padding-bottom: constant(safe-area-inset-bottom); /* iOS < 11.2 兜底 */
}
/* 按压反馈 */
.save-btn:active {
  transform: scale(0.98);
  opacity: 0.9;
  transition: all 0.1s ease;
}
/* ✅ 极小屏兜底：防止 32px 文字在窄屏弹窗中截断 */
@media (max-width: 350px) {
  .save-btn {
    font-size: 28px !important;
    letter-spacing: 0;
  }
}

/* 响应式适配（保持原有） */
@media screen and (max-width: 375px) {
  .package-name { font-size: 24px; }
  .metric-value { font-size: 28px; }
  .profit-amount { font-size: 32px; }
  .flow-metric .metric-value { font-size: 26px; }
  .header-bar { padding: 14px 16px; }
  .main-content { padding: 12px; }
  .profit-card { padding: 20px; }
  .config-price-btn {
    height: 44px !important;
    font-size: 20px !important;
    padding: 0 16px !important;
    line-height: 44px !important;
  }
}

.profit-note {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 8px 16px;
  margin: 0 16px 12px;
  font-size: 11px;
  color: #999; /* 浅灰色，弱化存在感 */
  line-height: 1.4;
}
.note-item {
  white-space: nowrap;
}

.divider {
  color: #ddd;
  font-size: 10px;
}
</style>
